module.exports = __webpack_public_path__ + "img/icon_2_11.24141581.png";